import React from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Col,
} from "reactstrap";
import { css } from "react-emotion";
import { Formik } from "formik";
import reports from "@/api/reports";
import { handleError } from "@/util/errorHandler";

const modalStyles = css`
  position: absolute;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  overflow: visible;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  width: 35rem;

  .buttons {
    display: flex;
    justify-content: space-between;
    margin: 15px 0 0;
  }
`;

const overlayStyles = css`
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: rgba(255, 255, 255, 0.75);
  z-index: 1021; /* above navs, below sweetalert */
`;

class AccountStatementModal extends React.Component {
  state = {
    phoneNumber: "",
    currency: "KHR",
    period: 0,
    periodOptions: [],
  };

  baseState = {
    ...this.state,
  };

  reset = () => {
    this.setState(this.baseState);
  };

  beforeClose = () => {
    this.reset();
    this.props.onModalClose();
  };

  downloadAccountStatement = async ({ currency, period }) => {
    try {
      const res = await reports.requestAccountStatement({
        currency,
        accountId: this.props.userAccountId,
        periodInMonth: period,
      });
      if (res.reportId) {
        this.beforeClose();
        window.location.href = "/download";
      }
    } catch (err) {
      handleError(err);
    }
  };

  componentDidMount() {
    reports.getPeriodOptions().then(res => {
      this.setState({ periodOptions: res.data });
    });
  }

  render() {
    const form = (
      <Formik
        initialValues={{
          currency: this.state.currency,
          period: this.state.period,
        }}
        onSubmit={this.downloadAccountStatement}>
        {({ values, handleSubmit, handleChange }) => (
          <Form onSubmit={handleSubmit}>
            <CardBody>
              <FormGroup row>
                <Label sm={4}>
                  <h6>Currency</h6>
                </Label>
                <Col sm={8}>
                  <Input
                    type="select"
                    name="currency"
                    id="currency"
                    value={values.currency}
                    onChange={event => handleChange(event)}>
                    <option value="KHR" key="KHR">
                      KHR
                    </option>
                    <option value="USD" key="USD">
                      USD
                    </option>
                  </Input>
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label sm={4}>
                  <h6>Statement period</h6>
                </Label>
                <Col sm={8}>
                  <Input
                    type="select"
                    name="period"
                    id="period"
                    value={values.period}
                    onChange={event => handleChange(event)}>
                    {this.state.periodOptions.map(option => (
                      <option value={option.value} key={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Input>
                </Col>
              </FormGroup>
            </CardBody>
            <CardFooter>
              <div className="buttons">
                <Button color="primary" type="submit">
                  <span>Generate PDF</span>
                </Button>
              </div>
            </CardFooter>
          </Form>
        )}
      </Formik>
    );

    return (
      <Modal
        isOpen={this.props.isOpen}
        onRequestClose={this.beforeClose}
        className={modalStyles}
        overlayClassName={overlayStyles}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}>
        <Card>
          <CardHeader>
            <Button close onClick={this.beforeClose} />

            <span>Generate Statement</span>
          </CardHeader>
          {form}
        </Card>
      </Modal>
    );
  }
}

AccountStatementModal.defaultProps = {
  isOpen: false,
  onModalClose: () => {},
  userAccountId: "",
};

AccountStatementModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onModalClose: PropTypes.func.isRequired,
  userAccountId: PropTypes.string.isRequired,
};

export default AccountStatementModal;
